// @ts-check

/**
 * @param {function} callback
 * @param {object} options
 */
function eventHandler(callback, options) {
  return (/** @type {Event} */ event) => {
    event.preventDefault()
    event.stopPropagation()
    callback({ ...options, event })
  }
}

module.exports = {
  eventHandler
}
